import { createSelector } from 'reselect';

import { apiCallStatus } from 'helpers/constants';
import { formatUploadList } from './helpers';

const getSelectedAsset = ({ powertrainAssetDetails }) => {
	return powertrainAssetDetails.selectedAsset;
};

const getUploadStatus = ({ bulkUploadV2 }) => {
	return bulkUploadV2.uploadStatus.data ? formatUploadList(bulkUploadV2.uploadStatus.data.uploads) : [];
};

const getIsUploadStatusLoading = ({ bulkUploadV2 }) => {
	return bulkUploadV2.uploadStatus.loadingStatus === apiCallStatus.LOADING;
};

export const getModel = createSelector([
	getSelectedAsset,
	getUploadStatus,
	getIsUploadStatusLoading
], (
	selectedAsset,
	uploadStatusList,
	isUploadStatusLoading
) => {
	return {
		selectedAsset,
		uploadStatusList,
		isUploadStatusLoading
	};
});
